import { AuthContext } from '@shared/context/AuthContext';
import React, { useContext, useEffect } from 'react';

import { NavLink } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

export function NavbarContainer(props: any) {
    const { user, setUser } = useContext(AuthContext);

    const { setShowLogout } = useContext(AuthContext);

    return (
        <header>
            <div className="main_header">
                <nav className="navbar">
                    <div className="container-fluid">
                        <div className="logo_sec_box">
                            <a className="sidebar_btn" onClick={props.hideNav}>
                                <span className="bun"></span>
                                <span className="bun"></span>
                                <span className="bun"></span>
                            </a>
                            <NavLink className="navbar-brand" to={'/home/dashboard'}>
                                <img className="logo_box img-fluid" src="assets/images/ebidding_logo.svg" alt="" />
                            </NavLink>
                        </div>
                        <div className="main_navbar_cover">
                            {/* <div className="dropdown bell_drop notification_drop_box">
                                <button
                                    className="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    id="notification_drop"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <img className="img-fluid" src="assets/images/bell_icon.svg" alt="" />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="notification_drop">
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            Notification 1
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            Notification 2
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            Notification 3
                                        </a>
                                    </li>
                                </ul>
                            </div> */}
                            <div className="dropdown user_drop">
                                <button
                                    className="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    id="user_box_drop"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {user ? user.name.charAt(0).toUpperCase() : 'A'}
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="user_box_drop">
                                    <li className="user_profile_box">
                                        <div className="user_img">{user ? user.name.charAt(0).toUpperCase() : 'A'}</div>
                                        <div className="user_info">
                                            <h3>{user ? user.name : 'Name'}</h3>
                                            <p>{user ? user.user_role.name : 'Role'}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li className="user_detail_box" style={{ fontSize: '13px' }}>
                                        <span className="info_side_box"> Mobile No: </span>
                                        {user ? user.phone : '999990000'}
                                    </li>
                                    {user && user.email && (
                                        <li className="user_detail_box" style={{ fontSize: '13px' }}>
                                            <span className="info_side_box"> Email:</span>
                                            {user.email}
                                        </li>
                                    )}
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <NavLink to="/home/helpSupport">
                                        {' '}
                                        <li className="user_detail_box" style={{ fontSize: '13px' }}>
                                            <span className="info_side_box">
                                                {' '}
                                                <img
                                                    className="img-fluid icon_img"
                                                    src="assets/images/side_icons/help_support.svg"
                                                    alt=""
                                                />{' '}
                                                &nbsp;Help & Supoort{' '}
                                            </span>
                                        </li>
                                    </NavLink>

                                    <li
                                        className="user_detail_box"
                                        style={{
                                            fontSize: '13px',
                                            marginTop: '5px',
                                            cursor: 'pointer',
                                            color: '#bb0a1e',
                                        }}
                                        onClick={() => {
                                            setShowLogout(true);
                                        }}
                                    >
                                        {' '}
                                        <span className="icon_box">
                                            <img
                                                className="img-fluid icon_img"
                                                src="assets/images/side_icons/log_out.svg"
                                                alt=""
                                            />
                                        </span>
                                        &nbsp; Log Out
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
}
